import React from 'react';
import './VeiculoseciaFinanciamento.scss';
import { Button, Divider } from '@mui/material';
import { FaWhatsapp } from 'react-icons/fa';
import { ParallaxBanner, ParallaxProvider } from 'react-scroll-parallax';
import financiamento from '../../../assets/images/home/truck-driver.jpg';
import { Link } from 'react-router-dom';

function VeiculoseciaFinanciamento() {
    return (
        <div className='bg-white'>
            <ParallaxProvider>
                <ParallaxBanner
                    layers={[{ image: financiamento, speed: 10 }]}
                    className='aspect-[2/1]'
                >
                    <div className='position-relative inset-0 flex items-center justify-center' style={{ height: '300px' }}>
                        <div className='veiculosecia__content d-flex flex-column justify-content-center h-100'>
                            <h6 className='text-8xl text-white' style={{ fontSize: '20px', fontWeight: 700 }}>Financiamento</h6>
                            <p className='text-white text-break m-0'>
                                A Veículos & Cia - Caminhões e Carretas facilita ao máximo o seu financiamento para proporcionar parcelas que cabem no seu bolso.
                            </p>
                        </div>
                    </div>
                </ParallaxBanner>
            </ParallaxProvider>
            {/* <div className='veiculosecia__content'>
                <div className='financiamento__content'>
                    <h6>Dados Pessoais</h6>
                    <p><b>CNH – D OU E</b> (CATEGORIA D OU E PARA CAMINHÕES TRUCKS OU CAVALOS MECÂNICOS)</p>
                    <p><b>RG E CPF</b> (DO FINANCIADO E DO CÔNJUGE)</p>
                    <p><b>ENDEREÇO COMPLETO E CEP</b></p>
                    <p><b>TELEFONES (FIXO E CELULAR)</b></p>
                </div>
                <Divider />
                <div className='financiamento__content'>
                    <h6 className='mt-4'>Comprovação de Renda</h6>
                    <p><b>LOCAL DE AGREGAMENTO</b> (LOCAL DE AGREGAMENTO OU ONDE TRABALHA)</p>
                    <p><b>NOME COMPLETO DA EMPRESA E CNPJ</b></p>
                    <p><b>ENDEREÇO COMPLETO DA EMPRESA E CEP</b></p>
                    <p><b>TELEFONES FIXOS E CELULARES</b></p>
                    <p><b>NOME DO INFORMANTE</b> (NOME DA PESSOA QUE VAI DAR  A INFORMAÇÃO)</p>
                    <p><b>FATURAMENTO BRUTO MÉDIO MENSAL</b></p>
                    <p><b>CARGO OCUPACIONAL:</b></p>
                    <p><b>CARGO NA EMPRESA:</b></p>
                    <p><b>1º AGREGADO</b></p>
                    <p><b>2º PRESTADOR DE SERVIÇO</b></p>
                    <p><b>3º TERCEIRIZADO</b></p>
                    <p><b>4º FUNCIONÁRIO</b></p>
                    <p><b>5º CHEFE DE TRANSPORTES</b></p>
                    <p><b>6º DONO DA EMPRESA</b>(CASO SEJA DONO DA EMPRESA, PASSAR NOME E TELEFONE DO CONTADOR)</p>
                </div>
                <Divider />
                <div className='financiamento__content'>
                    <h6 className='mt-4'>Referências</h6>
                    <p>INFORME NOME E TELEFONE DE <b>DUAS PESSOAS</b>, PODE SER PARENTE OU AMIGO.</p>
                    <p><b>DUAS REFERÊNCIAS COMERCIAIS</b> COM TELEFONE (PODE SER: POSTO DE GASOLINA, LOJA DE PEÇAS, PNEUS, FINANCEIRAS, LOJAS DE ACESSÓRIOS) ETC…</p>
                    <p><b>REFERÊNCIAS BANCÁRIAS</b> (NOME DO BANCO – AGÊNCIA – CONTA – TEMPO DE CONTA</p>
                </div>
                <Divider />
                <div className='financiamento__content'>
                    <h6 className='mt-4'>Propriedades</h6>
                    <p>INFORME MODELO E PLACA DE VEÍCULOS DE SUA PROPRIEDADE</p>
                </div>
                <Divider />
                <div className='financiamento__content'>
                    <h6 className='mt-4'>Valor e Prazo</h6>
                    <p>VALOR QUE QUER FINANCIAR E O PRAZO</p>
                </div>
                <p style={{ textAlign: 'center' }}>ENVIE TODOS OS DOCUMENTOS E INFORMES QUE FAREMOS A SOLICITAÇÃO DO FINANCIAMENTO DO CAMINHÃO, QUALQUER DÚVIDA BASTA LIGAR OU CHAMAR NO WHATSAPP: FINANCIAR CAMINHÃO NUNCA FOI TÃO FÁCIL.</p>
                <div className='financiamento__link'>
                    <h6>FAÇA A SOLICITAÇÃO DO FINANCIAMENTO AGORA:</h6>
                    
                    <Button 
                        startIcon={<FaWhatsapp />}
                        onClick={() => window.open('https://api.whatsapp.com/send/?phone=5566999815612&text=Olá, tenho interesse no financiamento', '_blank')}
                    >
                        Financiamento
                    </Button>
                </div>
            </div> */}
            <div className='veiculosecia__content'>
                <h4 className='font-bold'>✅ Taxa de abertura de crédito</h4>
                <h6 className='mb-5'>R$ 2.000</h6>

                <h4>✅ Sendo pagos na seguinte condição:</h4>

                <h6>➡️ Aprovando crédito e você vindo compra , ou até mesmo vindo e não agrada nos caminhões, terá R$ 2.000 de desconto ou a devolução do valor integral dos R$ 2.000</h6>

                <h6>➡️ Não  aprovando o crédito devolvemos o valor dos R$2.000 de forma integral na mesma conta de Origem</h6>

                <h6 className='mb-5'>➡️ Aprovando e você não vim comprar  os R$ 2.000  fica pago nosso serviço sem direito a devolução!</h6>

                <h4>Documentos para análise:</h4>

                <h6>➡️ CPF / RG /CNH</h6>
                <h6>➡️ CARTÃO CNPJ (se tiver )</h6>
                <h6>➡️ ENDEREÇO</h6>
                <h6>➡️ E-MAIL</h6>
                <h6>➡️ ANTT (se tiver )</h6>
                <h6>➡️ DOC CAMINHÃO EM NOME  (se tiver )</h6>
                <h6>➡️ FONES DE CONTATO</h6>

                <h4 className='my-5'>VEÍCULOS E CIA, Empresa sediada no pátio da transportadora Martelli, município de Jaciara - MT 🇧🇷</h4>

                <Link to='https://veiculoseciamt.com.br/contatos' target='_blank'>https://veiculoseciamt.com.br/contatos</Link>

                <h6 className='mt-3'>Nesse link você terá todas as nossas informações, como endereço, fones, localização, site, Instagram 👍🏽</h6>
            </div>
        </div>
    )
}

export default VeiculoseciaFinanciamento;
